import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { loadMe } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sid) { navigate("/login", { replace: true }); return; }
    (async () => {
      try {
        await api.post("/auth/google/session", { session_id: sid });
        window.history.replaceState(null, "", window.location.pathname);
        await loadMe();
        navigate("/home", { replace: true });
      } catch (e) {
        setError("Accesso con Google non riuscito. Riprova.");
        setTimeout(() => navigate("/login", { replace: true }), 2000);
      }
    })();
  }, [loadMe, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        {error ? <p className="text-destructive text-sm">{error}</p> : (
          <>
            <div className="h-10 w-10 rounded-full border-2 border-primary border-t-transparent animate-spin mx-auto" />
            <p className="text-muted-foreground text-sm mt-4">Accesso in corso…</p>
          </>
        )}
      </div>
    </div>
  );
}
